module.exports = __webpack_public_path__ + "img/昌辉.png";